// @core/api/endpoints/calendar/create_calendar.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CalendarResponse,
  CreateCalendarRequest,
} from '../../../types/calendar';

const BASE_PATH = '/calendar';

/**
 * Create calendar
 * Creates a new calendar (personal, team, shared, or project-linked). The caller becomes the calendar owner.
 */
export async function CreateCalendar(
  data: CreateCalendarRequest,
  options?: RequestOptions
): Promise<CalendarResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/calendars`;
  const requestOptions = options;
  return client.post<CalendarResponse>(requestPath, data, requestOptions);
}
